var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.4 10.2c2.4 0 4.6 2 4.6 4.6v40.6c0 2.4-2 4.6-4.6 4.6h-46.8c-2.4 0-4.6-2-4.6-4.6v-40.6c0-2.4 2-4.6 4.6-4.6h46.8z",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 28.8h-56",
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4 4v12.4",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6 4v12.4",
    fill: "none",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 50.6c0 0.8-0.6 1.6-1.6 1.6-0.8 0-1.6-0.6-1.6-1.6 0-0.8 0.6-1.6 1.6-1.6s1.6 0.8 1.6 1.6z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 50.6c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.6-1.6-1.6c0-0.8 0.6-1.6 1.6-1.6s1.6 0.8 1.6 1.6z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 50.6c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.8-1.6-1.6 0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 38.2c0 0.8-0.6 1.6-1.6 1.6-0.8 0-1.6-0.6-1.6-1.6s0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6 38.2c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.6-1.6-1.6 0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2 38.2c0 0.8-0.6 1.6-1.6 1.6s-1.6-0.8-1.6-1.6 0.6-1.6 1.6-1.6 1.6 0.8 1.6 1.6z",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidity);
export default __webpack_public_path__ + "static/media/validity.338493f28436d06b328f153de2fde611.svg";
export { ForwardRef as ReactComponent };